export default function ContactSection() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-message-3-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">お問い合わせ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            無料お見積り・<strong className="text-primary">ご相談</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            まずはお気軽にご相談ください。
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-xl text-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Phone */}
            <div className="p-6 bg-pink-50 rounded-xl border border-pink-100 h-full flex flex-col justify-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center shrink-0">
                  <i className="ri-phone-fill text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">お電話でのご相談</h3>
              </div>
              <a href="tel:0120-952-005" className="text-3xl md:text-4xl font-bold text-primary hover:text-pink-700 transition-colors block mb-2">
                0120-952-005
              </a>
              <p className="text-gray-600 text-sm">9:00-20:00 年中無休（年末年始・お盆除く）</p>
            </div>

            {/* Email/Form Link */}
            <div className="p-6 bg-gray-50 rounded-xl border border-gray-100 h-full flex flex-col justify-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center shrink-0">
                  <i className="ri-mail-send-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">WEBからのご相談</h3>
              </div>
              <p className="text-gray-600 mb-6 text-sm">
                LINEまたは専用のメールフォームより24時間いつでもお問い合わせいただけます。
              </p>
              <div className="flex flex-col gap-3">
                <a 
                  href="https://line.me/R/ti/p/%40578amvud" 
                  className="inline-flex items-center justify-center gap-2 w-full px-8 py-3 bg-[#06C755] text-white font-bold rounded-lg hover:bg-[#05b34c] transition-all shadow-lg cursor-pointer"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE見積もり
                </a>
                <a 
                  href="/gomiyashiki/contact" 
                  className="inline-flex items-center justify-center gap-2 w-full px-8 py-3 bg-primary text-white font-bold rounded-lg hover:bg-pink-600 transition-all shadow-lg cursor-pointer"
                >
                  <i className="ri-mail-send-line text-xl"></i>
                  メール見積もり
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}